import React from "react";
import Reveal from "./Reveal";

export default function FeatureCard({ icon: Icon, title, description, dark = false, delay = 0 }) {
  if (dark) {
    return (
      <Reveal delay={delay}>
        <div
          className="rounded-2xl p-7 h-full transition-all duration-300 hover:-translate-y-1"
          style={{
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
            backdropFilter: "blur(8px)",
          }}
          data-testid="feature-card"
        >
          <div className="w-12 h-12 rounded-xl bg-delfi-red/15 text-delfi-red flex items-center justify-center mb-5">
            {Icon && <Icon size={22} />}
          </div>
          <h3 className="text-white text-lg font-semibold mb-2 tracking-tight">{title}</h3>
          <p className="text-white/65 text-sm leading-relaxed">{description}</p>
        </div>
      </Reveal>
    );
  }

  return (
    <Reveal delay={delay}>
      <div className="delfi-card h-full" data-testid="feature-card">
        <div className="w-12 h-12 rounded-xl bg-delfi-red/10 text-delfi-red flex items-center justify-center mb-5">
          {Icon && <Icon size={22} />}
        </div>
        <h3 className="text-delfi-navy text-lg font-semibold mb-2 tracking-tight">{title}</h3>
        <p className="text-delfi-navy/70 text-sm leading-relaxed">{description}</p>
      </div>
    </Reveal>
  );
}
